import { PINLockPlayerPopup } from "/app/libraries/arcana/src/blocks/Popup/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useCallback, useEffect } from 'react'
import { aye } from '~/shared/helpers'
import { $unlockedId, resetUnlockId, unlockId } from '../../content'
import {
  $isValidPinCode,
  $pinLockPopupDescription,
  closePinLockPopup,
  emptyPinLockState,
  resetValidPinCode,
} from '../model'
import { usePinLockPlayerBase } from './usePinLockPlayerBase'

export const usePinLockPlayerPopup = (
  title?: string,
  content?: { id: number; locked?: boolean; name?: string } | null,
  pinLocked?: boolean
) => {
  const {
    pinLockPopup,
    openPinLockPopupEvent,
    autoSubmitPinCodeCallback,
    changePinCodeCallback,
  } = usePinLockPlayerBase()

  const closePinLockPopupEvent = useUnit(closePinLockPopup)
  const isValidPinCode = useUnit($isValidPinCode)
  const pinLockDescription = useUnit($pinLockPopupDescription)
  const resetUnlockIdEvent = useUnit(resetUnlockId)
  const resetValidPinCodeEvent = useUnit(resetValidPinCode)
  const unlockedChannelId = useUnit($unlockedId)
  const updateUnlockId = useUnit(unlockId)

  useEffect(() => {
    if (pinLocked && content) {
      openPinLockPopupEvent({
        ...emptyPinLockState,
        id: content.id,
        name: title ?? '',
        locked: aye(content.locked),
      })
    }
  }, [pinLocked, openPinLockPopupEvent, content, title])

  const PINLockPlayerPopupComponent = useCallback(
    () => (
      <PINLockPlayerPopup
        title={title}
        description={pinLockDescription}
        invalid={pinLockPopup.invalid}
        errorMessage={pinLockPopup.errorMessage}
        onCompleteInput={autoSubmitPinCodeCallback}
        onChangeInput={changePinCodeCallback}
        valueAfterInvalid={pinLockPopup.valueAfterInvalid}
      />
    ),
    [
      autoSubmitPinCodeCallback,
      changePinCodeCallback,
      pinLockDescription,
      pinLockPopup.errorMessage,
      pinLockPopup.invalid,
      pinLockPopup.valueAfterInvalid,
      title,
    ]
  )

  return {
    closePinLockPopup: closePinLockPopupEvent,
    isValidPinCode,
    PINLockPlayerPopupComponent,
    resetUnlockId: resetUnlockIdEvent,
    resetValidPinCode: resetValidPinCodeEvent,
    unlockedChannelId,
    updateUnlockId,
  }
}
